import React from 'react';
import { MoneyText } from '../common/MoneyAmount';
import '../../styles/cash-expected-breakdown.css';
/**
 * Soll-Berechnung Kassen-Écart:
 * Anfang + Verkäufe + Créance-Einzüge − Ausgänge = Attendu.
 */
const CashExpectedBreakdown = ({
  deviation,
  formatAmount,
  labels = {},
  showElectronic = false
}) => {
  if (!deviation) return null;

  const initialCash = Number(deviation.initialAmount) || 0;
  const initialElectronic = Number(deviation.initialElectronicAmount) || 0;
  const cashSales = Number(deviation.cashSales) || 0;
  const electronicSales = Number(deviation.electronicSales) || 0;
  const cashDebt = Number(deviation.cashDebtCollections) || 0;
  const electronicDebt = Number(deviation.electronicDebtCollections) || 0;
  const cashOutgoing = Number(deviation.cashOutgoing) || 0;
  const electronicOutgoing = Number(deviation.electronicOutgoing) || 0;
  const expectedCash = Number(deviation.expectedAmount) || 0;
  const expectedElectronic = Number(deviation.expectedElectronicAmount) || 0;

  const hasCashActivity =
    Math.abs(initialCash) > 0.001 ||
    Math.abs(cashSales) > 0.001 ||
    Math.abs(cashDebt) > 0.001 ||
    Math.abs(cashOutgoing) > 0.001 ||
    Math.abs(expectedCash) > 0.001;

  const hasElectronicActivity =
    showElectronic &&
    (Math.abs(initialElectronic) > 0.001 ||
      Math.abs(electronicSales) > 0.001 ||
      Math.abs(electronicDebt) > 0.001 ||
      Math.abs(electronicOutgoing) > 0.001 ||
      Math.abs(expectedElectronic) > 0.001);

  if (!hasCashActivity && !hasElectronicActivity) return null;

  const renderBlock = (title, rows, totalLabel, totalValue) => (
    <div className="cash-expected-breakdown__block">
      {title ? <div className="cash-expected-breakdown__block-title">{title}</div> : null}
      <div className="cash-expected-breakdown__rows">
        {rows.map((row) => (
          <div key={row.key} className={`cash-expected-breakdown__row cash-expected-breakdown__row--${row.kind}`}>
            <span>{row.label}</span>
            <strong><MoneyText>{formatAmount(row.value)}</MoneyText></strong>
          </div>
        ))}
        <div className="cash-expected-breakdown__row cash-expected-breakdown__row--total">
          <span>{totalLabel}</span>
          <strong><MoneyText>{formatAmount(totalValue)}</MoneyText></strong>
        </div>
      </div>
    </div>
  );

  const cashRows = [
    { key: 'initial', label: labels.initial, value: initialCash, kind: 'neutral' },
    { key: 'sales', label: labels.cashSales, value: cashSales, kind: 'in' }
  ];
  if (Math.abs(cashDebt) > 0.001) {
    cashRows.push({
      key: 'debt',
      label: labels.cashDebtCollections || '+ Créances',
      value: cashDebt,
      kind: 'in'
    });
  }
  cashRows.push({ key: 'out', label: labels.cashOutgoing, value: -cashOutgoing, kind: 'out' });

  const electronicRows = [
    { key: 'initialE', label: labels.initialElectronic, value: initialElectronic, kind: 'neutral' },
    { key: 'salesE', label: labels.electronicSales, value: electronicSales, kind: 'in' }
  ];
  if (Math.abs(electronicDebt) > 0.001) {
    electronicRows.push({
      key: 'debtE',
      label: labels.electronicDebtCollections || '+ Créances',
      value: electronicDebt,
      kind: 'in'
    });
  }
  electronicRows.push({
    key: 'outE',
    label: labels.electronicOutgoing,
    value: -electronicOutgoing,
    kind: 'out'
  });

  return (
    <div className="cash-expected-breakdown">
      <div className="cash-expected-breakdown__title">{labels.title}</div>
      {labels.hint ? <p className="cash-expected-breakdown__hint">{labels.hint}</p> : null}

      {hasCashActivity &&
        renderBlock(
          labels.cashSection || null,
          cashRows,
          labels.expectedCash,
          expectedCash
        )}

      {hasElectronicActivity &&
        renderBlock(
          labels.electronicSection || null,
          electronicRows,
          labels.expectedElectronic,
          expectedElectronic
        )}
    </div>
  );
};

export default CashExpectedBreakdown;
